<!-- <div class="NewDashboardContainer">
  
    <div class="container-fluid">
        <div class="customLeftNav">
              <div class="Items">
                    <div class="  bhoechie-tab-menu">
                            <div class="list-group">
                                    <a  [routerLink]="['/NewDashboard/Policy']" class="list-group-item  text-center" routerLinkActive="active">
                                      <h4 class="glyphicon glyphicon-dashboard"></h4><br/> Dashboard
                                    </a>
                                    <a  (click)="gotoProposalList()" class="list-group-item  text-center" routerLinkActive="active">
                                      <h4 class="glyphicon glyphicon-tasks"></h4><br/>My Proposals
                                    </a>
                                    <a   (click)="gotoNewPolicy()"  class="list-group-item addNew text-center" routerLinkActive="active">
                                      <h4 class="glyphicon glyphicon-plus"></h4><br/>Add New Policy
                                    </a>
                                    <a [routerLink]="['/NewDashboard/Profile']" class="list-group-item  text-center" routerLinkActive="active">
                                      <h4 class="glyphicon glyphicon-user"></h4><br/>Profile
                                    </a>
                                    <a  (click)="gotoLogout()"  class="list-group-item text-center">
                                      <h4 class="glyphicon glyphicon-log-out"></h4><br/>Logout
                                    </a>
                                  </div>
                          </div>
              </div>
        </div>

        <div class="RightContent">
            <div class="Clears"></div>
            <router-outlet></router-outlet>
                    
            
                  
        </div>
    </div>
</div> -->
<div class="Loading" *ngIf="showLoading==true">
  <div class="loader"></div>
  <!-- <img id="" src="assets/img/762.gif"   /> -->
  <label class="loaderlabel">Please wait while Processing....</label>
</div>


<!-- <nav class="navbar navbar-inverse"> -->
<div class="container-fluid">
  <div id="wrapper" [ngClass]="{'toggled': HasSide}">
    <div id="sidebar-wrapper">

      <div class="sidebar-brand">
        <a href="#">
          <img src="assets\theme\en\images\logo.png" width="170px">

        </a>

        <span class="CloseNav" (click)="ToggleClass()">X</span>
      </div>

      <ul class="sidebar-nav">
        <li class="nav-item" (click)="goToDashboard()">
          <span class="glyphicon glyphicon-briefcase ic" data-toggle="tooltip" title="{{'Dashboard'|translate}}"></span>
          <a class="nav-link" routerLinkActive="activelink" (click)="goToDashboard()">{{'Dashboard'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>
        <li class="nav-item" (click)="gotoProposalList()">
          <span class="glyphicon glyphicon-th-list ic" data-toggle="tooltip" title="{{'My Proposals'|translate}}"></span>
          <a class="nav-link" (click)="gotoProposalList()" routerLinkActive="activelink">{{'My Proposals'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>


        <li class="nav-item" (click)="gotoNewPolicy()">

          <i class="fa fa-file-text-o addnewpolicyicon" data-toggle="tooltip" title="{{'Add New Policy'|translate}}"></i>
          <a class="nav-link" (click)="gotoNewPolicy()" routerLinkActive="activelink">{{'Add New Policy'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>

        <!-- <<<<<<<< Renewal List Start >>>>> -->

        <li class="nav-item" (click)="gotoReNewPolicy()">
          <i class="fa fa-file-text-o addnewpolicyicon" data-toggle="tooltip" title="{{'Renew Policy'|translate}}"></i>
          <a class="nav-link" (click)="gotoReNewPolicy()" routerLinkActive="activelink">{{'Renew Policy'|translate}}</a>
        </li>

        <!-- <<<<<<<< Renewal List End >>>>> -->

        <!-- <<<<<<<< Claims Start >>>>> -->
        <li class="nav-item" (click)="GoToClaims()">
          <i class="fa fa-file-text-o addnewpolicyicon" data-toggle="tooltip" title="{{'Renew Policy'|translate}}"></i>
          <a class="nav-link" (click)="GoToClaims()" routerLinkActive="activelink">{{'Claims'|translate}}</a>
          <span style="margin-left: 96px;" class="glyphicon glyphicon-chevron-down ic" data-toggle="tooltip" title="{{'Claims'|translate}}"></span>
        </li>
        <!-- <<<<<<<< Claims End >>>>> -->

 
        <div class="submenu" *ngIf="ToggleClaims">
          <li class="nav-item" (click)="GoToSubmitClaim()">
            <a class="nav-link"   routerLinkActive="activelink">{{'Submit a Claim'|translate}}</a>
          </li>
          <li class="nav-item" (click)="GoToClaimStatus()">
            <a class="nav-link" routerLinkActive="activelink">{{'Check Claim Status'|translate}}</a>
          </li>
        </div>


        <li class="nav-item">
          <span class="glyphicon glyphicon-warning-sign ic" (click)="GoToComplaints()" data-toggle="tooltip" title="{{'Complaints'|translate}}"></span>
          <a class="nav-link" (click)="GoToComplaints()" target="_blank"  >{{'Complaints'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>

  

        <li class="nav-item" (click)="GoToProfile()">
          <span class="glyphicon glyphicon-user ic" data-toggle="tooltip" title="{{'Profile'|translate}}"></span>
          <a class="nav-link" (click)="GoToProfile()" routerLink="/NewDashboard/Profile" routerLinkActive="activelink">{{'Profile'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>

        <li class="nav-item" (click)="GoToPolicyWordings()">
          <span class="glyphicon glyphicon-book ic" data-toggle="tooltip" title="{{'Policy Wordings'|translate}}"></span>
          <a class="nav-link" (click)="GoToPolicyWordings()" routerLink="/NewDashboard/PolicyWordings" routerLinkActive="activelink">{{'Policy Wordings'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>

        <li class="nav-item" (click)="gotoLogout()">
          <span class="glyphicon glyphicon-log-out ic" data-toggle="tooltip" title="{{'Logout'|translate}}"></span>
          <a class="nav-link" (click)="gotoLogout()" routerLinkActive="activelink">{{'Logout'|translate}}</a>
          <!-- <i class="fa fa-angle-right ioncssub"></i> -->
        </li>





      </ul>

    </div>

    <div id="page-content-wrapper">
      <div class="headerTop">

        <span class="displayt"> {{'Welcome' | translate }} {{Lng=="ar"? InsuredNameAr:InsuredName}}</span>
        <a id="menu-toggle" (click)="ToggleClass()"> <i class="fa fa-bars" style="font-size:20px"></i></a>

        <div class="ColorPickerImg">
          <ul class="nav navbar-nav navbar-right" style="margin-right:20px;">
            <!-- <li class="langDisable"><button class="btn btn-warning languagechangebtn" (click)="changeLanguage('ar')"  *ngIf="isEnglish">عربي</button></li>
                            <li class="langDisable"><button class="btn btn-warning languagechangebtn" (click)="changeLanguage('en')" *ngIf="!isEnglish">English</button   ></li>
                           -->

            <li class="langDisable"><button class="LangButton" (click)="changeLanguage('ar')" *ngIf="isEnglish">
                <span></span>
                <span></span>
                <span></span>
                <span></span> عربي</button></li>
            <li class="langDisable"><button class="LangButton" (click)="changeLanguage('en')" *ngIf="!isEnglish">
                <span></span>
                <span></span>
                <span></span>
                <span></span> English</button></li>

          </ul>
        </div>

      </div>

      <div class="LoadContent">
        <div class="contentDiv">
          <router-outlet></router-outlet>
        </div>


      </div>
    </div>


  </div>

</div>


// WEBPACK FOOTER //
// D:/GGI/LIMRA_GGI/PROMOSND95/GGI_ONLINE_ANGULAR__2022_10_17_ClaimTracking/src/Pages/NewDashboard/NewDashboard.html